import { getUploadSignature } from "./uploadSignature";

/**
 * Send one file to Cloudinary with a signature from our server.
 *
 * The fields sent must be exactly the ones the server signed (timestamp, folder,
 * tags), or Cloudinary rejects the upload. Pass `permission` to reuse one
 * signature for several files; otherwise a fresh one is requested.
 *
 * Returns Cloudinary's JSON reply, which carries `error` when it refuses a file.
 */
export async function uploadToCloudinary(file, { resourceType = "auto", permission } = {}) {
  const signed = permission || (await getUploadSignature());
  const form = new FormData();
  form.append("file", file);
  form.append("api_key", signed.api_key);
  form.append("timestamp", signed.timestamp);
  form.append("signature", signed.signature);
  form.append("folder", signed.folder);
  form.append("tags", signed.tags);
  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${signed.cloud_name}/${resourceType}/upload`,
    { method: "POST", body: form }
  );
  return response.json();
}
